import { lazyPage } from 'app/client/utilities/lazy';

export default lazyPage(
  () => import(/* webpackChunkName: "domain-transfer-token/index" */ './index'),
);
